import React from 'react';
import { useSelector } from 'react-redux';
import useDocsBindDelete from '../../../../mutation/useDocsBindDelete';
import { Icon, Popconfirm } from 'antd';
import moment from 'moment';
import styles from './RelatedObject.module.scss';

const RelatedObject = ({ item }) => {
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const doc = useSelector(
    (state) => state.documentsStore.relatedDocsModalVisible
  );

  const { onBindDocsDelete, isLoading } = useDocsBindDelete();

  const handleConfirm = () => {
    onBindDocsDelete({
      documentId: doc?.id,
      bindEntityTypeId: item?.entityType?.id,
      bindEntityId: item?.id,
    });
  };

  const showDeleteBtn = Number(userInfo?.WorkerId) === item?.workerId;

  return (
    <div className={styles.item}>
      <Icon
        type="file"
        style={{ color: '#3378F9', fontSize: '20px', marginTop: 5 }}
      />
      <div className={styles.contentItem}>
        <div className={styles.nameItem}>
          {item?.type?.name} {item?.documentNumber || ''} от{' '}
          {moment(item?.bindDateTime).format('DD.MM.YYYY')}
        </div>
        <div className={styles.typeItem}>{item?.entityType?.name}</div>
        <div className={styles.statusItem}>Статус: {item?.status?.name}</div>
      </div>
      {showDeleteBtn && (
        <div className={styles.iconBox}>
          <Popconfirm
            placement="topRight"
            title={
              <p>
                Вы уверены, что хотите отвязать{' '}
                <strong>{item?.entityType?.name}</strong> от{' '}
                <strong>
                  {moment(item?.bindDateTime).format('DD.MM.YYYY')}
                </strong>
              </p>
            }
            onConfirm={handleConfirm}
            okText="Да"
            cancelText="Нет"
          >
            <Icon
              type={isLoading ? 'loading' : 'delete'}
              className={styles.deleteIcon}
            />
          </Popconfirm>
        </div>
      )}
    </div>
  );
};
export default RelatedObject;
